import { createSlice } from '@reduxjs/toolkit'

const initialSiteLaneState = {
  siteIdArray: [],
  siteListArray: [],
  laneIdListArray: [],
  laneActiveListArray: [],
  siteNameValue: '',
  siteDescriptionValue: '',
  siteNameString: '',
  siteIdValue: 0,
  laneNameValue: 0,
  laneSiteValue: 0,
  laneIpValue: '',
  lanePortValue: '',
  siteDevicePage: 1,
  laneDevicePage: 1,
  laneIdValue: 0,
  emailListValue: [],
  sitePermissionValue: false,
  userAcessList: [],
}

const siteLaneSlice = createSlice({
  name: 'siteLane',
  initialState: initialSiteLaneState,
  reducers: {
    siteIdArrayHandler(state, action) {
      state.siteIdArray = action.payload
    },
    siteListHandler(state, action) {
      state.siteListArray = action.payload
    },
    laneIdListHandler(state, action) {
      state.laneIdListArray = action.payload
    },
    laneActiveListHandler(state, action) {
      state.laneActiveListArray = action.payload
    },
    siteNameValueHandler(state, action) {
      state.siteNameValue = action.payload
    },
    siteDescriptionValueHandler(state, action) {
      state.siteDescriptionValue = action.payload
    },
    siteNameStringHandler(state, action) {
      state.siteNameString = action.payload
    },
    siteIdValueHandler(state, action) {
      state.siteIdValue = action.payload
    },
    laneIdValueHandler(state, action) {
      state.laneIdValue = action.payload
    },
    laneNameValueHandler(state, action) {
      state.laneNameValue = action.payload
    },
    laneSiteValueHandler(state, action) {
      state.laneSiteValue = action.payload
    },
    laneIpValueHandler(state, action) {
      state.laneIpValue = action.payload
    },
    lanePortValueHandler(state, action) {
      state.lanePortValue = action.payload
    },
    sitePageHandler(state, action) {
      state.siteDevicePage = action.payload
    },
    lanePageHandler(state, action) {
      state.laneDevicePage = action.payload
    },
    siteEmailListValueHandler(state, action) {
      state.emailListValue = action.payload
    },
    sitePermissionValueHandler(state, action) {
      state.sitePermissionValue = action.payload
    },
    siteUserAccessListHandler(state, action) {
      state.userAcessList = action.payload
    },
  },
})

export const siteLaneActions = siteLaneSlice.actions
export default siteLaneSlice.reducer
